// Constants used only by the Home feature.
import { AIMS_FLOWS } from "../../constants";

// DefaultView display constants
export const DEFAULT_VIEW_TEXT = {
  DEFAULT_TITLE: "Amazon Meetings",
  STOPPED_TITLE: "Amazon Meetings stopped",
  ATTENDEE_SUBTITLE: "Meeting organizers can turn on meeting summary.",
};

// Screen copy that differs between the summary and transcribe flows. ACTIVE is the status shown
// during a session when Assistant is off (no tabs); STOPPED_SUBTITLES are the Stop screen lines.
export const FLOW_TEXT = {
  [AIMS_FLOWS.SUMMARY]: {
    ACTIVE: "Summarizing...",
    STARTED: "turned on meeting summary",
    REJECTED: "is starting summary...",
    STOPPED_SUBTITLES: ["You'll receive a meeting summary when it's ready."],
  },
  [AIMS_FLOWS.TRANSCRIPT]: {
    ACTIVE: "Transcribing...",
    STARTED: "turned on transcription",
    REJECTED: "is starting transcription...",
    STOPPED_SUBTITLES: [
      "Start taking notes if needed.",
      "You'll receive a transcript and a meeting summary when it's ready.",
    ],
  },
};

// "Started by" status on the Assistant tab, dismissed after 20s or on a new chat session.
export const STARTED_BY_DISMISS_MS = 20000;

// Shown as a toast when enabling/disabling an agent (organizer toggle) fails.
export const AGENT_TOGGLE_ERROR_MESSAGE =
  "Something went wrong while updating the agent. Try again in a moment.";

// Scheduled-agent auto-activation, Case 1 (scheduled list fetch failed) and Case 3 (every
// scheduled agent failed to activate): nothing got activated, so both use this message.
// The Case-2 partial-failure message builder (scheduledAgentsPartialErrorMessage) lives in
// utils/AgentDisplayUtils.js
export const SCHEDULED_AGENTS_ALL_INACTIVE_MESSAGE =
  "All agents are inactive. Toggle them on in Settings.";
